import { postCall, getCall, genericGetCall } from '../../utils/apiCalls'
import { BaseURL } from '../../config';


import {
  INVENTORY_CALENDAR_VIEW,
  INVENTORY_ROUTE_LEVEL_VIEW,
  INVENTORY_ALL_ROUTES_REFRESH_DATA,
  INVENTORY_ROUTE_LEVEL_REFRESH_DATA,
  REJECTION_REASONS_DATA
} from './actionTypes'

import {
  GET_INVENTORY_VIEW,
  GET_INVENTORY_ROUTE_LEVEL_VIEW,
  INVENTORY_ALL_ROUTES_REFRESH,
  INVENTORY_REFRESH_URL,
  REJECTION_REASONS,
  DOWNLOAD_INVENTORY_CSV
} from '../../config/urls';

import FileDownload from "js-file-download";


export const fetchInventoryCalendarView = (payload) => dispatch => {
  const url = GET_INVENTORY_VIEW;
  postCall(url, payload)
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: INVENTORY_CALENDAR_VIEW,
          payload: { data: res.data || [] },
        })
      } else {
        const err = (res.response.data || {}).message || 'Error, Please try again.';
        alert(err);
      }
    })
}

export const fetchInventoryRouteLevelView = (date, isViaRoutes) => dispatch => {
  getCall(`${GET_INVENTORY_ROUTE_LEVEL_VIEW}?date=${date}&is_via_route=${Boolean(isViaRoutes)}`)
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: INVENTORY_ROUTE_LEVEL_VIEW,
          payload: { data: res.data || [] },
        })
      } else {
        alert('Error, Please try again.');
      }
    })
}

export const inventoryAllRoutesRefresh = (data) => dispatch => {
  postCall(INVENTORY_ALL_ROUTES_REFRESH, data)
    .then(res => {
      let isError = (res && res.response && res.response.status >= 400) || !res.data || !res.data.data || !res.data.data.services.length;
      if (isError) {
        return;
      }
      dispatch({
        type: INVENTORY_ALL_ROUTES_REFRESH_DATA,
        payload: { data: res.data || [] },
      })
    })
}

export const inventoryRouteLevelRefresh = (query) => dispatch => {
  postCall(INVENTORY_REFRESH_URL, query)
    .then(res => {
      let isError = (res && res.response && res.response.status >= 400) || !res.data || !res.data.body || !res.data.body.length;
      if (isError) {
        alert("No routes found in DB");
        return;
      } else {
        dispatch({
          type: INVENTORY_ROUTE_LEVEL_REFRESH_DATA,
          payload: { data: res.data || [] },
        })
        alert("Successfully Updated")
      }
    })
}

export const fetchRejectionReasons = (date, route_id) => dispatch => {
  getCall(`${REJECTION_REASONS}?date=${date}&paytm_route_id=${route_id}`)
  .then(res => {
    if (res && res.status === 200) {
      dispatch({
        type: REJECTION_REASONS_DATA,
        payload: { data: res.data || [] },
      })
    } else {
      alert('Error, failed to get reasons. Please try again.');
    }
  })
}

export const downloadCSV = (source, paramsObj) => () => {
  let url;
  if(source === 'daylevel'){
    url = BaseURL + DOWNLOAD_INVENTORY_CSV +`?date=${paramsObj.date}&provider_id=${paramsObj.pid}&operator_id=${paramsObj.oid}`;
  }
  else if(source === 'routelevel'){
    url = BaseURL + DOWNLOAD_INVENTORY_CSV +`?date=${paramsObj.date}&provider_id=${paramsObj.pid}&operator_id=${paramsObj.oid}&paytm_src_id=${paramsObj.srcId}&paytm_dest_id=${paramsObj.destId}`

  }
  genericGetCall(url).then((res) => {
    FileDownload(res.data, source === 'daylevel' ? `${paramsObj.date}.csv` : `${paramsObj.route}.csv`);
  });
};

